import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from 'models/field.interface';
import { UtilityService } from 'services';
@Component({
  templateUrl: './date.component.html',
})

export class DateComponent {
  field: FieldConfig;
  group: FormGroup;
  constructor(private util: UtilityService) { }

  setDate(e) {
    this.group.get(this.field.name).setValue(new Date(e).toISOString());
  }

  isRequired() {
    return this.util.isRequired(this.group.get(this.field.name));
  }
}
